(function () {

    'use strict';

    angular.module('iplusjs.exceptionHandler.eicis', [
        'lodash',
        'moment',
        'iplusjs.config',
        'iplusjs.integration',
        'iplusjs.utils.device'
    ])
        .service('ExceptionHandlerEicisService', ExceptionHandlerEicisService);

    ExceptionHandlerEicisService.$inject = [
        '$window',
        '$httpParamSerializerJQLike',
        'lodash',
        'moment',
        'AppConfig',
        'IntegrationService',
        'DeviceUtilsService'
    ];

    function ExceptionHandlerEicisService($window, $httpParamSerializerJQLike, _, moment, AppConfig, IntegrationService, DeviceUtilsService) {
        var that = this,
            regexErrorId = /.*\(Fehlereintrag-Nr:\s(\d*)\).*/,
            remoteLoggingConf = AppConfig.APP.logging.remoteLogging || {};

        that.init = init;
        that.getData = getData;
        that.getErrorId = getErrorId;

        function init() {}
        function getData(exceptionHandlerData, stringifiedStack, message) {
            var id = _.get(exceptionHandlerData, 'id');

            stringifiedStack = [
                'releaseId: ' + AppConfig.APP.releaseId,
                'url: ' + $window.location.href,
                'clientId: ' + id,
                'clientInfo: ' + _.template('<%= data.name ? data.name + ": " + data.version || "undefined" : "Browser undefined" %>, <%= data.osname ? data.osname + ": " + data.osversion || "undefined" : "OS undefined" %>', { variable: 'data' })(_.pick(DeviceUtilsService.getBrowser().bowser, ['name', 'version', 'osname', 'osversion'])),
                'message: ' + message,
                'stack: ' + stringifiedStack
            ].join('\n');

            if (remoteLoggingConf.httpMethod === 'POST') {
                return $httpParamSerializerJQLike({
                    p_sid: IntegrationService.getExternalSid(),
                    p_err_stack: stringifiedStack,
                    p_time: moment().unix()
                });
            } else {
                return {
                    p_sid: IntegrationService.getExternalSid(),
                    p_err_stack: stringifiedStack,
                    p_time: moment().unix()
                };
            }
        }
        function getErrorId(responseData) {
            var errorId;

            try {
                errorId = ((_.get(responseData, 'result.result') || '').match(regexErrorId) || [])[1];
            } catch (e) {
                errorId = null;
            }

            return errorId;
        }
    }

})();
